import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatNavbarModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { AccordionHeaderModule } from "@obg/ngx.ui.common";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { KycVerificationModule } from "./kyc-verification/kyc-verification.module";
import { OpenIdConnectModule } from "./open-id-connect/open-id-connect.module";
import { PhoneVerificationModule } from "./phone-verification/phone-verification.module";
import { VerificationPage } from "./verification.page";

const DIRECTIVES: any[] = [VerificationPage];

@NgModule({
	imports: [
		CommonModule,
		CoreContentModule,
		GlobalUiModule,
		MatNavbarModule,
		PhoneVerificationModule,
		KycVerificationModule,
		AccordionHeaderModule,
		OpenIdConnectModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class VerificationModule {}
